import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { URL_TIPO_ATENDIMENTOS, enviarNovaGTO, primeiraOrtodontia, buscarProcedimentos, buscarProcedimentoPorCodigo, buscarFaces, buscarDentesAreas, anexar, buscarDentistasRadiologia, URL_DENTISTAS_RADIOLOGIA } from '../base/util/url-util';
import { BaseService } from "../base/util/base.service";
import { AutenticacaoService } from "../autenticacao/autenticacao.service";
import { isNullOrUndefined } from "util";
import { PrestadorExecutante } from "../base/vo/prestador-executante";
import { DentistaRadiologia } from "../base/vo/dentista-radiologia";
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Subject } from 'rxjs';

@Injectable()
export class NovaGtoService extends BaseService{

	public isEnviandoGto = new Subject<boolean>();

    constructor(public http: HttpClient, public auth: AutenticacaoService,public messageService: MessageService){
            super(http,messageService);
        }

        tipoAtendimentoDropdown(prestadorExecutante?: PrestadorExecutante){
            let url = URL_TIPO_ATENDIMENTOS;
            url = this.isPrestadorExecutante(url, prestadorExecutante);
            return this.get(url);
        }

        isPrimeiraOrtodontia(codBeneficiario, prestadorExecutante?: PrestadorExecutante){
            let url = primeiraOrtodontia(codBeneficiario);
            url = this.isPrestadorExecutante(url, prestadorExecutante);
            return this.get(url);
        }

        //Lista completa
        buscarProcedimentos(tipoAtendimento, prestadorExecutante?: PrestadorExecutante){
            let url = buscarProcedimentos(tipoAtendimento);
            url = this.isPrestadorExecutante(url, prestadorExecutante);
            return this.get(url);
        }

        //Busca apenas um procedimento pelo código
        buscarProcedimentoPorCodigo(codigoProcedimento, tipoAtendimento, prestadorExecutante?: PrestadorExecutante){
            let url = buscarProcedimentoPorCodigo(codigoProcedimento, tipoAtendimento);
            url = this.isPrestadorExecutante(url, prestadorExecutante);
            return this.get(url);
        }

        //Busca a lista de dentes ou áreas
        buscarDentesAreas(codigoProcedimento, prestadorExecutante?: PrestadorExecutante){
            let url = buscarDentesAreas(codigoProcedimento);
            url = this.isPrestadorExecutante(url, prestadorExecutante);
            return this.get(url);
        }

        //Busca as faces que podem ser usadas no dente.
        buscarFaces(codigoProcedimento, codigoDenteArea, prestadorExecutante?: PrestadorExecutante){
            let url = buscarFaces(codigoProcedimento, codigoDenteArea);
            url = this.isPrestadorExecutante(url, prestadorExecutante);
            return this.get(url);
        }

        enviarNovaGto(gto){
            return this.post(enviarNovaGTO,gto);
        }

        isPrestadorExecutante(url, prestadorExecutante?: PrestadorExecutante){
            if(this.auth.isClinica && !isNullOrUndefined(prestadorExecutante) && !isNullOrUndefined(prestadorExecutante.codigo)){
                url = url+"?codigoPrestadorExecutante=" + prestadorExecutante.codigo;
            }
            return url;
        }

        buscarDentistaRadiologia(dentistaRadiologia: DentistaRadiologia){
            return this.post(buscarDentistasRadiologia, JSON.stringify(dentistaRadiologia));
        }
        
        anexarArquivo(file: File){
            let fd: FormData = new FormData();
            fd.append('file', file, file.name);
            return this.post(anexar(), fd, new HttpHeaders().set('Accept', 'application/json'));
        }
        
        emitIsEnviadoGto(val) {
	    	this.isEnviandoGto.next(val);
	    }
}


// WEBPACK FOOTER //
// ./src/app/components/nova-gto/nova-gto.service.ts